import { Extension } from '@tiptap/core';

export const ValidateDoc = Extension.create({
   name: 'validateDoc',

   addOptions() {
      return {
         doc: {},
         /* eslint-disable-next-line @typescript-eslint/no-empty-function */
         fallbackHandler: () => {},
      };
   },

   onCreate() {
      try {
         const doc = this.editor.schema.nodeFromJSON(this.options.doc);
         doc.check();
      } catch (err) {
         this.options.fallbackHandler(err);
      }
   },
});
